export default {
  err: 'Error',
  back: 'Back',
  next: 'Next',
  save: 'Save',
  delete: 'Delete'
}
